import { useCallback, useState } from 'react';

export default function useSearchFilter() {
  const [searchTerm, setSearchTerm] = useState('');
  const normalizedSearchTerm = searchTerm.toLowerCase();
  const onSearchChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  }, [setSearchTerm]);
  const searchIncludes = useCallback(
    (item: string) => item.toLowerCase().includes(normalizedSearchTerm),
    [normalizedSearchTerm],
  );

  return {
    searchTerm,
    onSearchChange,
    searchIncludes,
  };
}
